'use client';

import { useTranslations } from 'next-intl';

import type { RepairReturnMethod } from '@/lib/service/ecs/logisticsCapabilities';

import {
  RepairRequestBoutiqueSummary,
  type RepairRequestBoutiqueSummaryData,
} from './RepairRequestBoutiqueSummary';
import styles from './RepairRequestReturnMethodSummary.module.scss';

interface RepairRequestReturnMethodSummaryProps {
  returnMethod: RepairReturnMethod;
  serviceBoutique: RepairRequestBoutiqueSummaryData | null;
}

export function RepairRequestReturnMethodSummary({
  returnMethod,
  serviceBoutique,
}: Readonly<RepairRequestReturnMethodSummaryProps>) {
  const t = useTranslations('service.repairRequest.personal.returnMethod');

  return (
    <div className={styles.wrapper} data-testid="review-return-method-summary">
      <p className={styles.label}>
        {returnMethod === 'clientShipping' ? t('homeDelivery') : t('boutiquePickup')}
      </p>
      {returnMethod === 'boutiquePickup' && serviceBoutique ? (
        <RepairRequestBoutiqueSummary boutique={serviceBoutique} />
      ) : null}
    </div>
  );
}
